import IBaseListingResponse from "../../utils/api/base-listing-response";
import { IContactUs, IContactUsDetails } from "../../models/contactus/response";
import { IContactUsQuery } from "../../models/contactus/query";
import { DEFAULT_FUNCTION, DEFAULT_QUERY } from "../../utils/helpers/constants";
import { createContext } from "react";
import { IUpdateContactUs } from "../../models/contactus/request";

export type ContactUsLoading = "list" | "delete" | "details" | "update";

export interface IInternalState {
  allContactUs?: IContactUs[];
  loading: ContactUsLoading[];
  list?: IBaseListingResponse<IContactUs>;
  query: IContactUsQuery;
  details?: IContactUsDetails;
  
}

export const internalState: IInternalState = {
  loading: [],
  query: DEFAULT_QUERY,
  
};

export interface IExternalState extends IInternalState {
  actions: {
    getData: () => void;
    deleteContactUs: (id: number) => void;
    updateContactUs: (id: number, request: IUpdateContactUs) => void;
    setSearch: (search?: string) => void;
    setQuery: (query: IContactUsQuery) => void;
    getDetails: (id: number) => void;
    setDetails: (data?: IContactUsDetails) => void;
  };
}

export const externalState: IExternalState = {
  ...internalState,
  actions: {
    getData: DEFAULT_FUNCTION,
    deleteContactUs: DEFAULT_FUNCTION,
    setSearch: DEFAULT_FUNCTION,
    setQuery: DEFAULT_FUNCTION,
    getDetails: DEFAULT_FUNCTION,
    setDetails: DEFAULT_FUNCTION,
    updateContactUs: DEFAULT_FUNCTION
  },
};

const ContactUsContext = createContext(externalState);
export default ContactUsContext;
